import React from 'react';
import { withFormsy } from 'formsy-react';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import _ from 'lodash';

function TextFieldFormsy(props) {
  const importedProps = _.pick(props, [
    'invalidDateMessage',
    'format',
    'KeyboardButtonProps',
    'margin',
    'disableToolbar',
    'autoComplete',
    'autoFocus',
    'children',
    'className',
    'defaultValue',
    'disabled',
    'FormHelperTextProps',
    'fullWidth',
    'id',
    'InputLabelProps',
    'inputProps',
    'InputProps',
    'inputRef',
    'label',
    'multiline',
    'name',
    'onBlur',
    'onChange',
    'onFocus',
    'placeholder',
    'required',
    'rows',
    'rowsMax',
    'select',
    'SelectProps',
    'type',
    'variant',
    'onKeyDown',
    'maxDate',
    'minDate',
    'minDateMessage',
    'maxDateMessage'
  ]);
  
  const value = props.value;

  function changeValue(value) {
    props.setValue(value);
    if (props.onChange) {
      props.onChange(value);
    }
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        {...importedProps}
        onChange={changeValue}
        value={value}
      />
    </MuiPickersUtilsProvider>
  );
}

export default withFormsy(TextFieldFormsy);
